























































































































































































































































import { mapGetters, mapActions } from "vuex";
import eventBus from "./services/eventBus";
import Vue from "vue";
import sharedMethods from "./sharedMethods.js"

window.fbAsyncInit = function() {
  FB.init({
    appId: "483659222868793",
    xfbml: true,
    version: "v10.0",
  });
  FB.AppEvents.logPageView();
};

(function(d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {
    return;
  }
  js = d.createElement(s);
  js.id = id;
  js.src = "https://connect.facebook.net/en_US/sdk.js";
  fjs.parentNode.insertBefore(js, fjs);
})(document, "script", "facebook-jssdk");

(function(h, o, t, j, a, r) {
  h.hj =
    h.hj ||
    function() {
      (h.hj.q = h.hj.q || []).push(arguments);
    };
  h._hjSettings = { hjid: 1790978, hjsv: 6 };
  a = o.getElementsByTagName("head")[0];
  r = o.createElement("script");
  r.async = 1;
  r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
  a.appendChild(r);
})(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");

export default {
  name: "LayoutDefault",

  components: {},
  computed:{
     ...mapGetters(["getApi", "getHost", "getFirstUseState", "isLoggedIn"]),
  },

  data() {
    return {
      leftDrawerOpen: false,
      isHidden: false,
      image: "",
      showElements: true,
      miniState: true,
      drawer: false,
      selectedFiles: undefined,
      progressInfos: [],
      fileInfos: [],
      showDragOverlayOn: false,
      overlayCounter: 0,
      minimizeUploadManager: false,
      miniDisabled: false,
      tourRunning: false,
      onLine: navigator.onLine,
      steps: [
        {
          target: "#s-settings",
          content:
            "You can change your login & account information in your profile settings",
          params: {
            placement: "left",
          },
        },
        {
          target: ".overview",
          content:
            "Here you can find the latest update news and other important informations",
          params: {
            placement: "bottom",
          },
        },
        {
          target: "#s-short",
          content:
            "The shortcuts help you to perform the most common tasks directly from the dashboard",
          params: {
            placement: "top",
          },
        },
        {
          target: "#s-upload",
          content:
            "You can upload files using the shortcut or simply by dragging them into your browser. At any time - anywhere!",
          params: {
            placement: "top",
          },
        },
        {
          target: "#s-help",
          content:
            "We have a help section with the most common questions and issues. If you experience any other problems don't hesitate to contact us!",
          params: {
            placement: "top",
          },
        },
        {
          target: "#s-playlist",
          content:
            "Let's continue and create your first playlist! Please click on the shortcut below",
          params: {
            placement: "top",
          },
        },
      ],

      playlistSteps: [
        {
          target: "#s-createPlButton",
          content:
            "Click here to create your playlist",
          params: {
            placement: "right",
          },
        },
         {
          target: "#s-addMediaButton",
          content:
            "Click here to upload your first content, or simply drag it into your browser",
          params: {
            placement: "right",
          },
        },
        {
          target: "#FreewallContainer",
          content:
            "Drag your content into your playlist",
          params: {
            placement: "top",
          },
        },
        {
          target: "#s-scheduleTab",
          content:
            "You can schedule your playlist by clicking here",
          params: {
            placement: "right",
          },
        },
      ],

      startFirstUseTour: false,
      myTourCallbacks: {
        onStart: () => {
          if (
            this.$router.currentRoute.fullPath !== "/" &&
            this.$router.currentRoute.fullPath !== "/dashboard"
          ) {
            this.$router.push("/");
          }
          (this.startFirstUseTour = false), this.disableVueUseTour();
          this.miniState = false;
          this.tourRunning = true;
          this.miniDisabled = true;
        },
        onNextStep: (step) => {
          this.miniState = true;
          this.miniDisabled = false;

          if (step === 4) {
            this.tourRunning = false;
          } else {
            this.tourRunning = true
          }
        },
        onPreviousStep: (step) => {
          if (step === 1) {
            this.miniState = false;
            this.miniDisabled = true;
          }
        },
        onSkip: () => {
          this.disableVueUseTour();
          this.miniDisabled = false;
          this.tourRunning = false;
        },
        onFinish: () => {
          this.disableVueUseTour();
          this.tourRunning = false;

         if(this.$tours['dashTour'].currentStep === 5) {
            setTimeout(() => {
                this.$tours['playlistTour'].start()
            }, 2000);
          }
        },
      },
    };
  },
  watch: {
    onLine(v) {
      if (v) {
        sharedMethods.successNotify("Internet connection restored")
      } else {
        sharedMethods.errorNotify("Please check your internet connection")
      }
    },
  },
  mounted() {
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },
  async created() {
    /*if (Vue.prototype.$serverPath === "https://api.mirrads.de" || Vue.prototype.$serverPath === "https://api-b.mirrads.de") {
      console.log = () => {};
    }*/

    this.$router.currentRoute.path ? "/login" : this.refreshToken();

    setInterval(() => {
      if (this.$store.getters.isLoggedIn) this.refreshToken();
    }, this.$store.getters.getTokenExpireInMs - 10000);

    eventBus.$on("chooseFilesForUpload", () => {
      this.chooseFiles();
    });

    eventBus.$on("hideElements", () => {
      this.showElements = false;
    });

    if (!this.$store.getters.isLoggedIn) {
      if (this.$router.currentRoute.path !== "/login") {
        console.log(
          "MDE PUSHING TO LOGIN PAGE -> Current ROUTE:" +
            this.$router.currentRoute.path
        );
        this.$router.push("/login").catch((err) => {});
      }
      this.showElements = false;
    }

    this.username = this.$store.getters.getUser.username;
    this.vorname = this.$store.getters.getUser.Vorname;
    this.accID = this.$store.getters.getUser.AccID;

    this.image =
      this.$store.getters.getHost +
      "content/" +
      this.accID +
      "/thumb/profile.png";
  },

  async updated() {
    setTimeout(() => {
      if (this.$store.getters.isLoggedIn) {
        this.username = this.$store.getters.getUser.username;
        this.vorname = this.$store.getters.getUser.Vorname;
        this.accID = this.$store.getters.getUser.AccID;
        this.image =
          this.$store.getters.getHost +
          "content/" +
          this.accID +
          "/thumb/profile.png";



        this.showElements = true;
      }
    }, 5)

    if (this.getFirstUseState) {
       this.startFirstUseTour = true;
    }
  },
  methods: {
    ...mapActions(["fetchMediaFiles", "refreshToken", "setFirstUseState", "uploadFile"]),

    drawerClick(e) {
      // console.log("DRAWER CLICKED: " + this.miniState);
      // if in "mini" state and user
      // click on drawer, we switch it to "normal" mode
      if (this.miniState) {
        this.miniState = false;

        // notice we have registered an event with capture flag;
        // we need to stop further propagation as this click is
        // intended for switching drawer to "normal" mode only
        e.stopPropagation();
      }
    },
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === "online";
    },
    disableVueUseTour() {
      this.setFirstUseState(false);
    },
    showDragOverlay() {
      this.overlayCounter++;
      console.log("SHOW MDE DRAG OVERLAY");
      if (this.overlayCounter > 0) this.showDragOverlayOn = true;
    },
    hideDragOverlay() {
      this.overlayCounter--;
      console.log("HIDE MDE DRAG OVERLAY");
      if (this.overlayCounter <= 0) this.showDragOverlayOn = false;
    },

    chooseFiles() {
      console.log("MDE UPLOAD EMIT RECIEVED");
      document.getElementById("fileUpload").click();
    },

    logout() {
      this.showElements = false;

      this.$store.dispatch("logout").then(() => {
        console.log("dispatched state");
        this.$store.reset();
		if( this.$router.currentRoute.path !== "/login") {
			this.$router.push("/login");
		}
      });
    },
    selectFile() {
      /* this.progressInfos = []; */
      this.selectedFiles = event.target.files;

      for (let i = 0; i < this.selectedFiles.length; i++) {
        this.progressInfos[this.progressInfos.length] = {
          percentage: 0,
          fileName: this.selectedFiles[i].name,
          status: "uploading",
          size: (this.selectedFiles[i].size / 1000000).toFixed(1),
        };
      }
      this.uploadFiles();
    },
    selectFileDD(e) {
      this.hideDragOverlay();

      /* this.progressInfos = []; */
      this.selectedFiles = e.dataTransfer.files;

      for (let i = 0; i < this.selectedFiles.length; i++) {
        this.progressInfos[this.progressInfos.length] = {
          percentage: 0,
          fileName: this.selectedFiles[i].name,
          status: "uploading",
          size: (this.selectedFiles[i].size / 1000000).toFixed(1),
        };
      }
      this.uploadFiles();
    },

    uploadFiles() {
		for (let i = 0; i < this.selectedFiles.length; i++) {
			this.upload(
			i + (this.progressInfos.length - this.selectedFiles.length),
			this.selectedFiles[i]
			);
		}
    // TODO
	  // not working...
    // const list = document.querySelector('.upload-manager-list');
		// list.scrollTop = list.scrollHeight;
    },

    upload(idx, file) {
      const event = (progressEvent) => {
        this.progressInfos[idx].percentage = Math.round(
          (100 * progressEvent.loaded) / progressEvent.total
        );

        if (this.progressInfos[idx].percentage === 100) {
          this.progressInfos[idx].status = "processing";
          console.log(
            "MDE UPLOAD: " +
              this.progressInfos[idx].fileName +
              "is " +
              this.progressInfos[idx].status
          );
        }

       this.$set(this.progressInfos, idx, this.progressInfos[idx])

      }

      this.uploadFile({ file: file, onUploadProgress: event })
        .then((response) => {
          this.progressInfos[idx].status = "completed";
          console.log(
            this.progressInfos[idx].fileName +
              " is " +
              this.progressInfos[idx].status
          );

          this.$set(this.progressInfos, idx, this.progressInfos[idx])

          this.fetchMediaFiles();
        })
        .catch((err) => {
          let message = "Could not upload the file: " + file.name;
			console.log(err.data);
          this.progressInfos[idx].percentage = 0;
          sharedMethods.errorNotify(message)
        });
    },
  },
};
